module.exports = __webpack_public_path__ + "static/img/UBC老师_竺海华.f65831e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_竺海华.png
// module id = 3IIJ
// module chunks = 0